import React, {useEffect, useRef} from 'react';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "../Sidebar/icons.css"


const CustomeDatePicker = (props) => {
  const {className, placeholder, calendarPosition, name,onChange} = props;
    //////////////////////////////////////
    const calenderIconRef = useRef(null);
    const parentRef = useRef(null);
    const addNewIconToCalenderPlease = () => {
        calenderIconRef.current.classList.add("calender-icon-focus");
    }
    const removeNewIconToCalenderPlease = () => {
        calenderIconRef.current.classList.remove("calender-icon-focus");
    }

    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
        function handleClick(e ) {
            if(parentRef && parentRef.current){
                const ref = parentRef.current
                if(!ref.contains(e.target)){
                   removeNewIconToCalenderPlease();
                }
            }
        }
    }, []);


    function CalenderCustomInputIcon({openCalendar, value, handleValueChange, name, placeholder}) {
        return (
            <div
                ref={parentRef}
                onClick={() => {
                    addNewIconToCalenderPlease();
                    openCalendar()
                }}
                onBlur={removeNewIconToCalenderPlease}
                onChange={removeNewIconToCalenderPlease}

                className={"d-flex justify-content-around"}
            >
                <input
                    className="rmdp-input text-center"
                    onClick={() => {
                        addNewIconToCalenderPlease();
                        openCalendar()
                    }}
                    onBlur={removeNewIconToCalenderPlease}
                    value={value}
                    onChange={handleValueChange}
                    name={name}
                    placeholder={placeholder}
                />
                <i ref={calenderIconRef}
                   className="calender-icon"
                   onClick={() => {
                       addNewIconToCalenderPlease();
                       openCalendar()
                   }}
                   onBlur={removeNewIconToCalenderPlease}
                   onChange={removeNewIconToCalenderPlease}
                />
            </div>
        )
    }

//////////////////////////////////
    return (
        <>
            <DatePicker
                calendar={persian}
                className={className}
                placeholder={placeholder}
                locale={persian_fa}
                calendarPosition={calendarPosition}
                onChange={(date) => {
                  if (date) {
                    props.onChange(date.toLocaleString())
                  } else {
                    props.onChange("")
                  }
                }}
                value={props.value}
                render={
                    <CalenderCustomInputIcon
                        placeholder={placeholder}
                        name={name}
                    />
                }
            />
        </>
    );
};

export default CustomeDatePicker;